var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-box"},[_c('div',{staticClass:"footer w1200",class:{'index-path': _vm.$route.name === _vm.ROUTER_MAP.home}},[_c('p'),_c('p')])])
}
var staticRenderFns = []

export { render, staticRenderFns }